import { useQuery } from "@tanstack/react-query"
import { apiClient } from "../helpers/Axios"

export const useUtilities = () => {
    return useQuery({
        queryKey: ['utility'],
        queryFn: async () => {
            const res = await apiClient.get('/utility/get-all');
            return res.data
        },
        refetchOnWindowFocus: false
    })
}